import { useState, useEffect, useMemo } from 'react';
import { Col, Container, Row, Nav, Tab, TabContent } from 'react-bootstrap';
import { useLoaderData } from 'react-router-dom';
import { PaymentReport } from './Reports/PaymentReport';
import { RecurringReports } from './Reports/RecurringReports';
import { ServerTransferSavedReportResponse, FacilityApi, ServerTransferFacilityLite, ServerTransferRecurringReportScheduleResponse } from './shared/api/axios-client';
import { createApiService } from './shared/apiConfig';
import { ArrowRepeat } from 'react-bootstrap-icons';
import './ReportsPage.css';

export function OperatorReportsPage() {
    const [initialPaymentReports, recurringReports] = useLoaderData() as [
        ServerTransferSavedReportResponse[],
        ServerTransferRecurringReportScheduleResponse[]
    ];
    const [paymentSavedReports, setPaymentSavedReports] = useState(initialPaymentReports);
    const [facilities, setFacilities] = useState<ServerTransferFacilityLite[]>([]);
    const [selectedFacilityIds, setSelectedFacilityIds] = useState<number[]>([]);
    const [activeTab, setActiveTab] = useState('revenue');

    // Load facilities on component mount and initially select all
    useEffect(() => {
        const loadFacilities = async () => {
            const facilityService = createApiService(FacilityApi);
            const response = await facilityService.listFacilitiesLite({});
            if (response.data.items) {
                // Filter out facilities without facilityId
                const validFacilities = response.data.items.filter(f => f.facilityId !== undefined);
                setFacilities(validFacilities);
            }
        };
        loadFacilities();
    }, []);

    const allSavedReports = useMemo(() => 
        paymentSavedReports.map((r) => ({ id: r.savedReportId!, name: r.name!, type: r.type! })),
        [paymentSavedReports]
    );

    return (
        <Container fluid className="h-100 d-flex flex-column overflow-hidden">
            <Row className="flex-grow-1">
                <Col className="h-100">
                    <Nav variant="tabs" activeKey={activeTab} onSelect={(k) => setActiveTab(k || 'revenue')} className="mb-3 d-flex">
                        <Nav.Item>
                            <Nav.Link eventKey="revenue">Revenue</Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="ms-auto">
                            <Nav.Link eventKey="recurring">
                                <ArrowRepeat className="me-1 icon-shift-up" />
                                Recurring Reports
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                    
                    <TabContent>
                        <Tab.Pane eventKey="revenue" active={activeTab === 'revenue'}>
                            <PaymentReport
                                facilityIds={selectedFacilityIds}
                                facilities={facilities}
                                savedReports={paymentSavedReports}
                                setSavedReports={setPaymentSavedReports}
                                heightOffset={120}
                            />
                        </Tab.Pane>
                        <Tab.Pane eventKey="recurring" active={activeTab === 'recurring'}>
                            <RecurringReports 
                                savedReports={allSavedReports} 
                                recurringReports={recurringReports}
                            />
                        </Tab.Pane>
                    </TabContent>
                </Col>
            </Row>
        </Container>
    );
} 